// Intro.js
function Intro() {
  return (
    <>
      <div
       className="alert alert-success">
        <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>
          <b>Situs "Hitung" : Situs Kalkulator Online Gratis Terbesar di Dunia Arab</b>
        </h1>
        <p>
          Situs "Hitung" adalah platform terkemuka berbahasa Arab yang menyediakan kumpulan lengkap kalkulator online gratis untuk membantu Anda melakukan perhitungan dengan cepat dan akurat di bidang keuangan, kebugaran, kesehatan, pendidikan, matematika dan aljabar, trigonometri, pecahan, fisika, statistik, teknologi, manajemen waktu, dan banyak lagi.
        </p>
      </div>
      <hr />
    </>
  )
}
export default Intro;